'use strict'

define('core',[
  'angular',
  'angularRoute',
  'angularResource',
  'angularMaterial',
  'angularAnimate',
  'angularAria',
  'angularSanitize',
  //'moment',
  //'angularMoment',
  'mdDataTable',
  'angularSortableView',
  'angularHotKeys',
  'app/util/BitArray',
  'app/services/shared',
  'app/services/empty',
  'app/filters/sumOfValue',
  'app/controllers/login',
  'app/controllers/main',
  'app/controllers/generic',
  'app/controllers/propietaris',
  'app/controllers/arrendataris',
  'app/controllers/pagaments',
  'app/controllers/rebuts',
  'app/controllers/liquidacions',
  'app/controllers/angular-locale_es-es',
  'app/directives/left_menu',
  'app/directives/actions_view',
  'app/directives/column_picker',
  'app/directives/file_read'
], function (angular) {
  // Declare app level module which depends on views, and components
  var app = angular.module('core', [
    'ngRoute',
    'ngMaterial',
    'ngSanitize',
    'app.shared',
    'app.main',
    'app.filters',
    'app.columnpicker',
    'app.login',
    'app.generic',
    'app.propietaris',
    'app.arrendataris',
    'app.pagaments',
    'app.rebuts',
    'app.liquidacions',
    'app.empty.service',
    'app.left_menu',
    'app.actions.view',
    'md.data.table',
    'cfp.hotkeys',
    'angular-sortable-view',
    'app.fileread'
  ])

    app.component('myAutocomplete', {
        bindings: {
            elemId: '=',
            ngDisabled: '=',
            results: '=',
            mdFloatingLabel: '@',
            textItem: '@',
            idPath: '@'
        },
        template: `
    <md-autocomplete
      ng-init="$ctrl.$onInit"
      ng-trim="false"
      md-selected-item-change="$ctrl.mdSelectedItemChange(item)"
      md-selected-item="$ctrl.selectedItem"
      md-search-text="$ctrl.searchText"
      md-delay="400"
      md-no-cache="true"
      md-autoselect="true"
      md-mode="virtual"
      md-items="item in $ctrl.filterElems()"
      md-item-text="$ctrl.textItemFn(item)"
      ng-disabled="$ctrl.ngDisabled"
      md-floating-label="{{$ctrl.mdFloatingLabel}}">
      <md-item-template><span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{$ctrl.textItemFn(item)}}</span></md-item-template>
      <md-not-found>Sin resultados</md-not-found>
    </md-autocomplete>
  `,
        controller: ['$scope', function($scope) {
            const ctrl = this;
            ctrl.searchText = '';

            ctrl.textItemFn = function(it) {
                return $scope.$eval(ctrl.textItem, {item: it, b:2});
            }

            ctrl.getElem = function(path, val) {
                var ret = _.find(ctrl.results, function (el) {
                    return el[path] === val;
                });
                if (ret === undefined)
                    return null;
                return ret;
            };

            ctrl.mdSelectedItemChange = function(p) {
                //console.log('selectedItemChange: ', p, ctrl.selectedItem);
                if (p) {
                    ctrl.elemId = p[ctrl.idPath];
                } else {
                    ctrl.elemId = null;
                }
            }
            ctrl.filterElems = function() {
                if (ctrl.searchText) {
                    let lcQuery = ctrl.searchText.toLowerCase();
                    return ctrl.results.filter(function(element) {
                        var elText = ctrl.textItemFn(element).toLowerCase();
                        return elText.includes(lcQuery);
                    });
                }
                return ctrl.results;
            };
            ctrl.$onInit = function() {
                $scope.$watch(
                    () => ctrl.elemId,
                    (newVal, oldVal) => {
                        if (!newVal || typeof newVal === 'object') {
                            ctrl.selectedItem = null
                        } else if (newVal !== oldVal) {
                            ctrl.selectedItem = ctrl.getElem(ctrl.idPath, newVal);
                        }
                    });
                if (ctrl.elemId && typeof ctrl.elemId !== 'object') {
                    ctrl.selectedItem = ctrl.getElem(ctrl.idPath, ctrl.elemId);
                }
            };
            ctrl.$onChanges = function(ev) {
                //console.log(ev);
            };
        }]
    });

    app.component('ocellotAutocomplete', {
        bindings: {
            elemId: '=',
            ngDisabled: '=',
            collection: '@',
            qryField: '@',
            orderBy: '@',
            mdFloatingLabel: '@',
            textItem: '@',
            idPath: '@'
        },
        template: `
    <md-autocomplete
      ng-init="$ctrl.$onInit"
      ng-trim="false"
      md-selected-item-change="$ctrl.mdSelectedItemChange(item)"
      md-selected-item="$ctrl.selectedItem"
      md-search-text="$ctrl.searchText"
      md-delay="400"
      md-no-cache="true"
      md-autoselect="true"
      md-mode="virtual"
      md-items="item in $ctrl.filterElems()"
      md-item-text="$ctrl.textItemFn(item)"
      ng-disabled="$ctrl.ngDisabled"
      md-floating-label="{{$ctrl.mdFloatingLabel}}">
      <md-item-template><span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{$ctrl.textItemFn(item)}}</span></md-item-template>
      <md-not-found>Sin resultados</md-not-found>
    </md-autocomplete>
  `,
        controller: ['$scope', '$http', 'sharedProperties', function($scope, $http, sharedProperties) {
            const ctrl = this;
            ctrl.searchText = '';
            ctrl.results = [];
            const apiBaseUrl = sharedProperties.getApiBaseUrl();

            ctrl.textItemFn = function(it) {
                return $scope.$eval(ctrl.textItem, {item: it, b:2});
            }
            
            ctrl.getElem = function(path, val) {
                return $http.get(apiBaseUrl + ctrl.collection + '?' + ctrl.idPath + '=' + val).then(function (response) {
                    return response.data.Results[0];
                });
            };

            ctrl.mdSelectedItemChange = function(p) {
                //console.log('selectedItemChange: ', p, ctrl.selectedItem);
                if (p) {
                    ctrl.elemId = p[ctrl.idPath];
                } else {
                    ctrl.elemId = null;
                }
            }
            ctrl.filterElems = function() {
                let q = ctrl.qryField;
                if (!q) q = 'Q';
                let o = ctrl.orderBy;
                if (!o) {
                    o = ''
                } else {
                    o = '&OrderBy=' + o;
                }

                return $http.get(apiBaseUrl + ctrl.collection + '?XXCache=false&SolveRefs=false' + o + '&' + q + '=' + ctrl.searchText).then(function (response) {
                    return response.data.Results;
                });
            };
            ctrl.$onInit = function() {
                $scope.$watch(
                    () => ctrl.elemId,
                    (newVal, oldVal) => {
                        if (!newVal || typeof newVal === 'object') {
                            ctrl.selectedItem = null
                        } else if (newVal !== oldVal) {
                            ctrl.getElem(ctrl.idPath, newVal).then(e => ctrl.selectedItem = e);
                        }
                    });
                if (ctrl.elemId && typeof ctrl.elemId !== 'object') {
                    ctrl.getElem(ctrl.idPath, ctrl.elemId).then(e => ctrl.selectedItem = e);
                }
            };
            ctrl.$onChanges = function(ev) {
                //console.log(ev);
            };
        }]
    });

  app.factory('loadMultiple', ['$http', '$q', function($http, $q) {
    return {
      loadDataFromUrls: function(urls) {
        var deferred = $q.defer();
        var urlCalls = [];
        angular.forEach(urls, function(url) {
          urlCalls.push($http.get(url.url));
        });
        // they may, in fact, all be done, but this
        // executes the callbacks in then, once they are
        // completely finished.
        $q.all(urlCalls).then(
          function(results) {
            deferred.resolve(results)
          },
          function(errors) {
            deferred.reject(errors);
          },
          function(updates) {
            deferred.update(updates);
          });
        return deferred.promise;
      }
    };
  }]);

  app.factory('loadMultipleMap', ['$http', '$q', function($http, $q) {
    return {
      loadDataFromUrls: function(urls) {
        var deferred = $q.defer();
        var urlCalls = [];
        angular.forEach(urls, function(url) {
          urlCalls.push($http.get(url));
        });
        // they may, in fact, all be done, but this
        // executes the callbacks in then, once they are
        // completely finished.
        $q.all(urlCalls).then(
          function(results) {
            deferred.resolve(results)
          },
          function(errors) {
            deferred.reject(errors);
          },
          function(updates) {
            deferred.update(updates);
          });
        return deferred.promise;
      }
    };
  }]);

  app.run(['$rootScope', '$location', '$http', 'sharedProperties', function ($rootScope, $location, $http, sharedProperties) {
    $rootScope.user = null;
	var apiBaseUrl = sharedProperties.getApiBaseUrl();
    $http.get(apiBaseUrl + 'who').then(function (response) {
      if (response.data.hasOwnProperty('Id') && response.data.hasOwnProperty('UserName'))
        $rootScope.userName = response.data.UserName;
      else
        $location.url('/login');
    })
  }]);

  app.run(['$rootScope', 'apiRoot', function ($rootScope, apiRoot) {
    var source = new EventSource(apiRoot+'event-stream?channel=OperMsg&t=' + new Date().getTime());
    var lastMessage = 0;
    $(source).handleServerEvents({
      handlers: {
        OperationMessage: function(opMsg) {
          if (lastMessage != opMsg.MsgId) {
            lastMessage = opMsg.MsgId;
            $rootScope.$broadcast('op-msg', opMsg);
            //console.log(aforo);
          }
        }
      },
    });

  }]);

  app.run(['$rootScope', function ($rootScope) {
    // Funcions globals!

      $rootScope.FilterElems = function (arr, path, val) {
      if (val) {
          let lcQuery = val.toLowerCase();
          return arr.filter(function(element) {
              return element[path].toLowerCase().includes(lcQuery);
          });
      }
      return arr;
    };

    $rootScope.GetElem = function(arr, path, val) {
      //console.log('rootScope.GetElem', arr, path, val)
      var ret = _.find(arr, function (el) {
        return el[path] === val;
      });
      if (ret === undefined)
        return null;
      return ret;
    };

    $rootScope.GetIndex = function(arr, path, val) {
      //console.log('rootScope.GetIndex')
      return arr.findIndex(function (el) {
        return (el[path] == val);
      });
    };

    $rootScope.AddElem = function(arr, val) {
      //console.log('rootScope.AddElem')
      if (!arr)
        arr = new Array();
      arr.push(val);
      return arr;
    }

    $rootScope.AddProp = function(elem, key, val) {
      if (!elem)
        elem = new Object();
      elem[key] = val;
      console.log(elem);
      return elem;
    }
    $rootScope.RemoveProp = function(elem, key) {
      if (!elem)
        elem = new Object();
      delete elem[key];
      console.log(elem);
      return elem;
    }

  }]);

  app.run(['$rootScope', 'hotkeys', function ($rootScope, hotkeys) {
    var scope = $rootScope.$new();
    $rootScope.$on('$routeChangeSuccess', function (event, route) {
      scope.$destroy();
      scope = $rootScope.$new();
      var isActive = function (act, id) {
        if (act === null || angular.isUndefined(act)) {
          return false
        }
        if (act.enablePolicy === 'allways') {
          return act.active //true
        } else if (act.enablePolicy === 'never') {
          return false
        } else if (act.enablePolicy === 'perItem') {
          if (!act.hasOwnProperty('ids')) {
            return false
          }
          var ids = act.ids
          for (var i = 0; i < ids.length; i++) {
            if ((act.isInt && parseInt(ids[i]) === parseInt(id)) || (!act.isInt && ids[i] === id)) {
              return act.active //true
            }
          }
          return false;
        }
        return false
      };

      var state = route.locals.state;
      if (!state) return;
      var hk = [];
      angular.forEach(state.elemActions, function (act) {
        if (act.hotkey){
          hk.push(act);
        }
      });
      angular.forEach(state.actions, function (act) {
        if (act.hotkey){
          hk.push(act);
        }
      });

      angular.forEach(hk, function (act) {
        hotkeys.bindTo(scope).add(act.hotkey, act.name, function(hotkey) {
          if (isActive(act, route.scope.id)) {
            act.active = false
            route.scope.$emit('naction', act, route.scope.id, event)
          }
        });
      });
    });

    $rootScope.$on("$routeChangeStart", function (event, next, current) {
      /*if (!Auth.authorize(next.access)) {
       if(Auth.isLoggedIn()) $location.url('/');
       else                  $location.url('/login');
       }*/
      //console.log("event", event);
      //console.log('next', next);
      //console.log('current', current);
    });

  }]);

  app.run(['$rootScope', function ($rootScope) {
    $rootScope.$on("$routeChangeStart", function (event, next, current) {
      /*if (!Auth.authorize(next.access)) {
       if(Auth.isLoggedIn()) $location.url('/');
       else                  $location.url('/login');
       }*/
      //console.log("event", event);
      //console.log('next', next);
      //console.log('current', current);
    });

  }]);

  app.config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
      //$locationProvider.html5Mode(true);
      app.routeProvider = $routeProvider;
      $routeProvider.when('/login', {
        templateUrl: 'templates/login.html',
        controller: 'LoginController'
      }).otherwise({
        redirectTo: '/main'
      })
    }
  ])

  app.config(['$mdIconProvider', function ($mdIconProvider) {
    $mdIconProvider.defaultIconSet('img/mdi.svg')
    $mdIconProvider.iconSet('action', 'img/svg-sprite-action.svg', 24)
    $mdIconProvider.iconSet('editor', 'img/svg-sprite-editor.svg', 24)
    $mdIconProvider.iconSet('content', 'img/svg-sprite-content.svg', 24)
    $mdIconProvider.iconSet('navigation', 'img/svg-sprite-navigation.svg', 24)
    /*$mdIconProvider.iconSet('action', 'bower_components/material-design-icons/sprites/svg-sprite/svg-sprite-action.svg', 24)
    $mdIconProvider.iconSet('editor', 'bower_components/material-design-icons/sprites/svg-sprite/svg-sprite-editor.svg', 24)
    $mdIconProvider.iconSet('content', 'bower_components/material-design-icons/sprites/svg-sprite/svg-sprite-content.svg', 24)
    $mdIconProvider.iconSet('navigation', 'bower_components/material-design-icons/sprites/svg-sprite/svg-sprite-navigation.svg', 24)*/
  }])

  app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.withCredentials = true
  }])

  app.factory('httpRequestInterceptor', [function () {
    return {
      request: function (config) {
        config.withCredentials = true
        //if (config.url[0] == '/') config.url='/api'+config.url
        return config
      }
    }
  }])

  app.config(['$httpProvider', function ($httpProvider) {
    delete $httpProvider.defaults.headers.common['X-Requested-With']
    $httpProvider.interceptors.push('httpRequestInterceptor')

    // Mulst login interceptor
    $httpProvider.interceptors.push('my401Interceptor')

    // Loading interceptor
    $httpProvider.interceptors.push('loadingInterceptor')
  }])

  app.factory('loadingInterceptor', ['$q', 'LoadingService', function ($q, LoadingService) {
    var concurrentRequestCounter = 0;
    return {
      request: function(config) {
        concurrentRequestCounter++;
        LoadingService.setLoading(concurrentRequestCounter > 0)
        return config
      },
      requestError: function(rejection) {
        if (concurrentRequestCounter > 0) concurrentRequestCounter--;
        LoadingService.setLoading(concurrentRequestCounter > 0)
        return $q.reject(rejection)
      },
      response: function(response) {
        if (concurrentRequestCounter > 0) concurrentRequestCounter--;
        LoadingService.setLoading(concurrentRequestCounter > 0)
        return response
      },
      responseError: function(rejection) {
        if (concurrentRequestCounter > 0) concurrentRequestCounter--;
        LoadingService.setLoading(concurrentRequestCounter > 0)
        return $q.reject(rejection)
      }
    }
  }])

  app.directive('myAnchor', function() {
	  return {
		restrict: 'A',
		link: function(scope, elem, attrs, ngModel) {
		  return elem.bind('click', function() {
			var desti = attrs['myAnchor']
			var el = document.getElementById(desti);
			return el.scrollIntoView();
		  });      
		}
	  };
	});

  app.directive('fileModel', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;

        element.bind('change', function () {
          scope.$apply(function () {
            modelSetter(scope, element[0].files[0]);
          });
        });
      }
    };
  }])

    app.directive("preview", function () {
        function link(scope, element) {
            let iframe = document.createElement('iframe');
            element[0].appendChild(iframe);
            
            let body = iframe.contentDocument.body;
            scope.$watch('content', function () {
                if (body) {
                    body.innerHTML = scope.content;
                }
            });
        }
    
        return {
            link: link,
            restrict: 'E',
            scope: {
                content: '='
            }
        };
    });

  app.service('fileUpload', ['$http', function ($http) {
    this.uploadFileToUrl = function (file, uploadUrl) {
      var fd = new FormData();
      fd.append('file', file);
      return $http.post(uploadUrl, fd, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      });
    }
  }])

  app.service('LoadingService', ['$rootScope', function ($rootScope) {
    var service = this

    service.setLoading = function (loading) {
      $rootScope.loadingView = loading
    }
  }])

  app.factory('my401Interceptor', ['$q', '$location', '$injector', function($q, $location, $injector) {

    var showError = function(errorResponse) {
      var sharedProperties = $injector.get('sharedProperties');
      var text = sharedProperties.getErrorMessage(errorResponse)
      var $mdDialog = $injector.get('$mdDialog');

      var alert = $mdDialog.alert()
          //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Error al realitzar l\'acció!')
          .htmlContent(text)
          .ariaLabel('Error al realitzar l\'acció!')
          .ok('Tancar!')
          //.targetEvent(ev)

      $mdDialog.show(alert)
    }

    return {
      responseError: function(rejection) {
        if (rejection.status == 401) {
          //console.log('must log in', rejection)
          $location.path('/login')
          return $q.reject(rejection)
        }

        showError(rejection);
        //console.log('responseError', rejection)
        return $q.reject(rejection)
      }
    }
  }])

  app.config(['$httpProvider', function ($httpProvider) {
      // Gestiona els strings que son date!!
      // Inicialment de la versió: https://gist.github.com/ScottGuymer/9994dae637bb2055d58b      
      // Actualitzat utilitzant https://www.myintervals.com/blog/2009/05/20/iso-8601-date-validation-that-doesnt-suck/
      // Simplificat pel problema de CM que tracta com a DateTime el valor: 3025-006
      // inicial: var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/
      // act1: var regexIso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
      // using code from https://stackoverflow.com/questions/12756159/regex-and-iso8601-formatted-datetime 
      var regexIso8601 = /^((((\d{4})(-((0[1-9])|(1[012])))(-((0[1-9])|([12]\d)|(3[01]))))(T((([01]\d)|(2[0123]))((:([012345]\d))((:([012345]\d))(\.(\d+))?)?)?)(Z|([\+\-](([01]\d)|(2[0123]))(:([012345]\d))?)))?)|(((\d{4})((0[1-9])|(1[012]))((0[1-9])|([12]\d)|(3[01])))(T((([01]\d)|(2[0123]))(([012345]\d)(([012345]\d)(\d+)?)?)?)(Z|([\+\-](([01]\d)|(2[0123]))([012345]\d)?)))?))$/;
//1100460610495012537035084000	  
	  // from moment.js
	  // iso 8601 regex

	  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
//var extendedIsoRegex = /^((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
//var basicIsoRegex = /^((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    function convertDateStringsToDates (root, input) {
      // Ignore things that aren't objects.
      if (typeof input !== 'object') return input

      for (var key in input) {
        if (!input.hasOwnProperty(key)) continue

        var value = input[key]
        var match
        // Check for string properties which look like dates.
        if (typeof value === 'string' && value.length >= 8 && (match = value.match(regexIso8601))) {
          var milliseconds = Date.parse(match[0])
          if (!isNaN(milliseconds)) {
            var dt = new Date(milliseconds)
            input[key] = dt
            //console.log((root === '' ? '$' : root) + '.' + key, '=', dt.toISOString(), "from", value)
          }
        } else if (typeof value === 'object') {
          // Recurse into object
          convertDateStringsToDates(root + (root !== '' ? '.' : '') + key, value)
        }
      }
    }

    $httpProvider.defaults.transformResponse.push(function (responseData) {
      convertDateStringsToDates('', responseData)
      // console.log(responseData)
      return responseData
    })
  }])

  app.config(['$mdThemingProvider', function ($mdThemingProvider) {
    console.log('set theme')
    $mdThemingProvider.theme('alt')

      .primaryPalette('indigo')
      .accentPalette('pink')
      .warnPalette('red')
      .backgroundPalette('blue-grey')

  /*
  .primaryPalette('red')
  .accentPalette('red');
  */
  // .warnPalette('red')
  // .backgroundPalette('red')
  /*
          $mdThemingProvider.theme('default')
              .primaryPalette('indigo')
              .accentPalette('pink')

          $mdThemingProvider.theme('alt')
              .primaryPalette('orange')
              .accentPalette('green')
  */
  }])

    app.config(["$provide", function ($provide) {
      var apiRoot = $("#APIRoot").attr("href")
      if (angular.isUndefined(apiRoot)) {
          apiRoot = ''; // prev: '/' // '/api/' // "http://localhost:8088/"; //"http://92.186.21.64:8090/"
          console.log('APIRoot not defined, defaults to ""')
      }
      $provide.value("apiRoot", apiRoot);
    }])

/*
app.controller('MainController', ['$scope', '$mdDialog', function($scope, $mdDialog) {
   $scope.keySearchModal = function(event) {
        if (event.ctrlKey && event.keyCode == 13) {
            $scope.openSearchModal()
        }
    }

    $scope.openSearchModal = function() {
        $mdDialog.show({
            templateUrl: 'templates/search_modal.html',
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                //ticketParent: ticket,
                //commentsParent: comments,
                //filesParent: files
            },
            //controllerAs: 'commentAddModal',
            //controller: SearchModalController
        })
    }
}]);
*/
})
;
